import { useState, useEffect, useRef, useCallback } from 'react';

export const useScrollSpy = () => {
  const [activeSection, setActiveSection] = useState('home');
  
  // Create refs for all sections
  const sectionRefs = useRef({
    home: useRef(null),
    services: useRef(null),
    about: useRef(null),
    contact: useRef(null),
    faq: useRef(null)
  }).current;

  // Scroll to section function
  const scrollToSection = useCallback((section) => {
    if (sectionRefs[section]?.current) {
      const yOffset = -80; // Adjust for fixed navbar height
      const element = sectionRefs[section].current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }, [sectionRefs]);

  // Memoized scroll handler to prevent unnecessary re-renders
  const handleScroll = useCallback(() => {
    const scrollPosition = window.scrollY + 100; // Offset for navbar
    
    // Check which section is currently in view
    Object.entries(sectionRefs).forEach(([key, ref]) => {
      if (ref.current) {
        const { offsetTop, offsetHeight } = ref.current;
        const sectionTop = offsetTop;
        const sectionBottom = offsetTop + offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          setActiveSection(key);
        }
      }
    });
  }, [sectionRefs]);

  // Effect to handle scroll spy functionality
  useEffect(() => {
    // Add scroll listener
    window.addEventListener('scroll', handleScroll);
    
    // Call once to set initial active section
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return {
    activeSection,
    sectionRefs,
    scrollToSection
  };
};